import strSim from "string-similarity";

export const skipColum = {
  text: "-Skip-",
  value: "@SKIPVALUE",
};

export const columns = [
  // {
  //     value: 'DeptNo',
  //     text: 'Dept',
  // },
  // {
  //     value: 'DeptName',
  //     text: 'Dept Desc',
  // },
  // {
  //     value: 'VendorNo',
  //     text: 'Vend',
  // },
  // {
  //     value: 'VendorName',
  //     text: 'Vend Desc',
  // },
  {
    value: "VendorPid",
    text: "Vend PID",
  },
  {
    value: "VendorPidDesc",
    text: "Vendor PID Desc",
  },
  {
    value: "MbksPid",
    text: "PID",
  },
  {
    value: "MbksPidDesc",
    text: "PID Desc",
  },
  {
    value: "MbksClass",
    text: "Class",
  },
  {
    value: "MbksClassName",
    text: "Class Desc",
  },
  {
    value: "MbksSubClass",
    text: "SubCl",
  },
  {
    value: "MbksSubClassName",
    text: "Subclass Desc",
  },
  {
    value: "Cost",
    text: "Cost",
  },
  {
    value: "TicketRetail",
    text: "Ticket Retail",
  },
  {
    value: "CompareAt",
    text: "Compare At",
  },
  {
    value: "CompareAtSource",
    text: "Compare At Source",
  },
  {
    value: "CompareAtSourceDesc",
    text: "Compare At Source Desc",
  },
  {
    value: "CompareAtNotes",
    text: "Compare At Notes",
  },
  {
    value: "AndUp",
    text: "And Up",
  },
  {
    value: "Source",
    text: "Source",
  },
  {
    value: "Season",
    text: "Season",
  },
  {
    value: "MultiOf",
    text: "Multi-Of",
  },
  {
    value: "TicketType",
    text: "Ticket Type",
  },
  {
    value: "MasterStyleDiv",
    text: "Div Master STY",
  },
  {
    value: "MasterStyle",
    text: "Master #",
  },
  {
    value: "MasterStyleName",
    text: "Master STY Desc",
  },
  {
    value: "VndColorName",
    text: "Vendor Color",
  },
  {
    value: "NrfColor",
    text: "NRF Color",
  },
  {
    value: "NrfColorName",
    text: "NRF Color Name",
  },
  {
    value: "MbksStyleSeq",
    text: "Mbks Style Seq",
  },
  {
    value: "MbksMarkStyleNo",
    text: "Mbks Mark StyleNo",
  },
  {
    value: "MbksMarkStyleName",
    text: "Mbks Mark StyleName",
  },
  {
    value: "VendorUpc",
    text: "Vendor Upc",
  },
  {
    value: "CorpInHouseUpc",
    text: "Corp InHouseUpc",
  },
  {
    value: "Quantity",
    text: "Quantity",
  },
  {
    value: "AllocationNotes",
    text: "Allocation Notes",
  },
];

// Import columns

export const importColumns = [
  {
    value: "VendorPid",
    text: "Vend PID",
  },
  {
    value: "VendorPidDesc",
    text: "Vend PID Desc",
  },
  {
    value: "MbksClass",
    text: "Class",
  },
  {
    value: "MbksSubClass",
    text: "SubCl",
  },
  {
    value: "Cost",
    text: "Cost",
  },
  {
    value: "TicketRetail",
    text: "Ticket Retail",
  },
  {
    value: "CompareAt",
    text: "Compare At",
  },
  {
    value: "CompareAtSource",
    text: "Compare At Source",
  },
  {
    value: "CompareAtNotes",
    text: "Compare At Notes",
  },
  {
    value: "AndUp",
    text: "And Up",
  },
  {
    value: "Source",
    text: "Source",
  },
  {
    value: "Season",
    text: "Season",
  },
  {
    value: "MultiOf",
    text: "Multi-Of",
  },
  {
    value: "MasterStyle",
    text: "MSTSTY #",
  },
  {
    value: "MasterStyleDiv",
    text: "Div/MSTSTY",
  },
  {
    value: "VndColorName",
    text: "Vendor Color",
  },
  {
    value: "NrfColor",
    text: "NRF Color",
  },
  {
    value: "NrfSize",
    text: "NRF Size",
  },
  {
    value: "NrfSizeName",
    text: "Size Desc",
  },
  {
    value: "MbksStyleSeq",
    text: "Style Seq",
  },
  {
    value: "VendorUpc",
    text: "Vendor UPC",
  },
  {
    value: "MbksMarkStyleName",
    text: "MKST Desc",
  },
  {
    value: "Quantity",
    text: "QTY",
  },
  {
    value: "Quantity",
    text: "Initial Qty",
  },
  {
    value: "AllocationNotes",
    text: "Allocation Notes",
  },
];

export const cdpColumns = [
  {
    value: "SellingDeptNo",
    text: "Selling Dept",
  },
  {
    value: "SellingVendorNo",
    text: "Selling Vend",
  },
  {
    value: "SellingPid",
    text: "Selling PID",
  },
  {
    value: "SellingNrfColor",
    text: "Selling NRF Color",
  },
  {
    value: "SellingUpc",
    text: "Selling UPC",
  },
  {
    value: "MbksPidDesc",
    text: "Buying PID Desc",
  },
  {
    value: "PurchaseQty",
    text: "Purchase QTY",
  },
  {
    value: "Cost",
    text: "CDP Cost",
  },
  {
    value: "TicketRetail",
    text: "Buying Ticket Retail",
  },
  {
    value: "CompareAt",
    text: "Compare At",
  },
  {
    value: "CompareAtSource",
    text: "Compare At Source",
  },
  {
    value: "CompareAtNotes",
    text: "Compare At Notes",
  },
  {
    value: "AndUp",
    text: "And Up",
  },
  {
    value: "Season",
    text: "Season",
  },
  {
    value: "MbksClass",
    text: "Buying Class",
  },
  {
    value: "MultiOf",
    text: "Multi-Of",
  },
  {
    value: "MasterStyleDiv",
    text: "Div/MSTSTY",
  },
  {
    value: "MasterStyle",
    text: "MSTSTY #",
  },
  {
    value: "MbksStyleSeq",
    text: "Style Seq",
  },
  {
    value: "MbksMarkStyleName",
    text: "MKST Desc",
  },
  {
    value: "AllocationNotes",
    text: "Allocation Notes",
  },
];

function strToToken(str) {
  return str != null && str.toLowerCase().replace(/\s+/g, "");
}

export function sortColumnNames(columnNames, str_ = "") {
  const str = strToToken(str_);
  const withToken =
    columnNames != null &&
    columnNames.map((col) => {
      const token = strToToken(col.text);
      return {
        ...col,
        token: token,
        heuristic: str && strSim.compareTwoStrings(str, token),
      };
    });
  const sorted = withToken.slice();
  sorted.sort((a, b) => b.heuristic - a.heuristic);
  return sorted;
}

export const statusCode = {
  InProgress: "inprogress",
  PdfError: "pdferror",
  Complete: "complete",
};



// WEBPACK FOOTER //
// ./utilities/columnNames.js